// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2":"patient","123":"case","224":"register","391":"info","430":"doctor","857":"report","962":"home","966":"login"}[chunkId] + "." + {"2":"2e29aee1","123":"b66efcfc","224":"03b3403f","391":"56e109b9","430":"eb9e4be6","857":"6ce12f3e","962":"88609112","966":"ff6de906"}[chunkId] + ".css";
};